module.exports = __webpack_public_path__ + "static/media/destaques_conteudos.1ead9b6d.jpg";